@let hasShiftUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);

<button
  nz-button
  nzType="primary"
  class="w-100 fw-normal"
  [disabled]="
    !hasShiftUpdatePermission || !canReleaseShifts || isOperationOnGoing
  "
  (click)="releaseShifts()"
  nz-tooltip
  [nzTooltipTitle]="
    !hasShiftUpdatePermission ? ('general.forbidden_action' | translate) : ''
  "
>
  {{ 'shift.page.release_selected' | translate }}
</button>
